import { useNavigate } from "react-router-dom";
import gifWave from "../../resources/images/scope.gif";
import { brand } from "../../Data/siteContent";
import "./MobileTopBar.css";

const MobileTopBar = () => {
  const navigate = useNavigate();

  return (
    <div className="mobile-topbar">
      <div className="mobile-topbar-inner">
        <button className="mobile-topbar-title" type="button" onClick={() => navigate("/")}>
          {brand.name}
        </button>
        <div className="mobile-topbar-gif-container">
          <img className="mobile-topbar-gif" src={gifWave} alt="Wave animation" />
        </div>
      </div>
    </div>
  );
};

export default MobileTopBar;
